/**
 * Format a school's registration-opens timestamp for the get-started flow.
 *
 * Values stored at exactly midnight UTC are legacy date-only schedules (the
 * Customers app used to write `YYYY-MM-DD` → `T00:00:00Z`), so they render as
 * a bare date in UTC. Anything else was scheduled with an explicit time and
 * renders as a date + time with a timezone abbreviation in `timeZone` (the
 * school's schedule timezone, so every visitor sees the same wall clock) —
 * or the viewer's local timezone when none is provided.
 */
export function formatRegistrationOpensAt(iso: string | null, timeZone?: string): string | null {
  if (!iso) {
    return null
  }
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) {
    return null
  }
  if (isUtcMidnight(date)) {
    return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
  }
  return date.toLocaleString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
    timeZone,
  })
}

function isUtcMidnight(date: Date): boolean {
  return (
    date.getUTCHours() === 0 &&
    date.getUTCMinutes() === 0 &&
    date.getUTCSeconds() === 0 &&
    date.getUTCMilliseconds() === 0
  )
}
